export default __webpack_public_path__ + "static/media/logo.8af1a810.png";